import dayjs from 'dayjs';

// 'Annonce publiée' and 'Réservation en attente': the only two statuses of a
// guard still open for booking. Mirrors `isSupervisionAvailable` in the API
// (src/utils/supervisionAvailability.js), which stays the authority — this is
// only here so a pensioner is not shown a dead reserve button.
export const AVAILABLE_SUPERVISION_STATUSES = ['PUBLISHED', 'WAITING_BOOKING'];

/**
 * Tells whether a guard can still be booked: published or awaiting a booking,
 * not archived, and not started yet. A guard stored without a start date is
 * kept, nothing proves it is over.
 *
 * @param {Object} supervision - The supervision to check.
 * @returns {boolean} True when the guard is still open for booking.
 */
export const isSupervisionAvailable = (supervision) => {
  if (!supervision?.main_informations) return false;
  if (supervision.is_archived !== false) return false;
  if (!AVAILABLE_SUPERVISION_STATUSES.includes(supervision.status))
    return false;

  const startDate = supervision.main_informations.start_date;

  if (!startDate) return true;

  return dayjs(startDate).isAfter(dayjs(), 'day');
};
